import { defineStore } from 'pinia'
import Vue from 'vue'

// The API issues per-environment session cookie names (infra compute.bicep):
// dev-/test- prefixed hosts get 'sessionid-<env>'; prod and localhost keep the
// bare Django default. Any client-side session check must use this name.
const hostname = typeof window === 'undefined' ? '' : window.location.hostname
const envMatch = hostname.match(/^(dev|test)-/)
export const SESSION_COOKIE_NAME = envMatch ? `sessionid-${envMatch[1]}` : 'sessionid'

export const userStore = defineStore('user', {
  state: () => ({
    isLoggedIn: false,
    loginChallenge: 0
  }),
  getters: {
    doubleCount: (state) => state.count * 2,
  },
  actions: {
    checkLoginState() {
      let sessionid = Vue.$cookies.get(SESSION_COOKIE_NAME)
      if (sessionid) {
        this.logUserIn()
      } else {
        this.logUserOut()
      }
    },
    logUserIn() {
      this.isLoggedIn = true
    },
    logUserOut() {
      let domain = '.' + process.env.VUE_APP_TLD
      Vue.$cookies.remove(SESSION_COOKIE_NAME, null, domain)
      if (SESSION_COOKIE_NAME !== 'sessionid') {
        // also clear the legacy shared-name cookie from before the per-env rename
        Vue.$cookies.remove('sessionid', null, domain)
      }
      this.isLoggedIn = false
    },
    issueLoginChallenge() {
      this.loginChallenge++
    }
    // logUserIn() {
    //   this.isLoggedIn = true
    //   window.localStorage.setItem('token', token)
    //   this.token = token
    //   if (token) {
    //     this.isLoggedIn = true
    //   } else {
    //     window.localStorage.removeItem('token')
    //     this.isLoggedIn = false
    //   }
    // }
  },
})
